import { useState } from "react";
import { Check, Copy } from "lucide-react";
import { toast } from "sonner";
import { cn } from "@/lib/utils";

export function CopyBlock({ block, idx, compact = false }) {
  const [copied, setCopied] = useState(false);
  const text = block?.text || "";
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = text;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      ta.remove();
    }
    setCopied(true);
    toast.success(`${block.label} copied`);
    setTimeout(() => setCopied(false), 1600);
  };
  return (
    <div className="rounded-xl border border-border surface overflow-hidden" data-testid={`copy-block-${idx}`}>
      <div className="flex items-center justify-between px-4 h-10 border-b border-border">
        <div className="flex items-center gap-3">
          <span className="text-xs font-semibold">{block.label}</span>
          <span className="font-mono-ls text-[10px] text-muted-foreground" data-testid={`copy-block-${idx}-count`}>{text.length} chars</span>
        </div>
        <button type="button" onClick={copy} data-testid={`copy-block-${idx}-button`} className={cn("inline-flex items-center gap-1.5 text-xs font-medium rounded-full px-3 h-7 transition-colors", copied ? "bg-gold text-black" : "hover:bg-muted text-muted-foreground hover:text-foreground")}>
          {copied ? <Check className="h-3.5 w-3.5" /> : <Copy className="h-3.5 w-3.5" />}
          {copied ? "Copied" : "Copy"}
        </button>
      </div>
      <pre className={cn("px-4 py-3 text-sm whitespace-pre-wrap font-sans leading-relaxed text-foreground/90", compact ? "max-h-28 overflow-auto scrollbar-thin" : "max-h-72 overflow-auto scrollbar-thin")}>{text || <span className="text-muted-foreground italic">Empty</span>}</pre>
    </div>
  );
}

export function CopyBlocks({ blocks = [], compact }) {
  return (
    <div className="space-y-3" data-testid="copy-blocks">
      {blocks.map((b, i) => <CopyBlock key={`${b.label}-${i}`} block={b} idx={i} compact={compact} />)}
    </div>
  );
}
